import {OwnershipDocument} from "../models/OwnershipDocument";
import {ParamSettings} from "../models/ParamSettings";
import {OwnershipDocumentImportTemplate} from "./OwnershipDocumentImportTemplate";
import {OwnershipDocumentTemplateData} from "./OwnershipDocumentTemplateData";
import {srpsCalculation} from "../services/SprsService";
import {cloneDeep} from "lodash";

export const getOwnershipDocumentTemplate = (data: OwnershipDocument, settings: ParamSettings[]) => {
    return OwnershipDocumentImportTemplate(prepareData(data, settings))
};

const prepareData = (documentData: OwnershipDocument, settings: ParamSettings[]) => {
    const templateData: OwnershipDocumentTemplateData = {
        documentOfImport: cloneDeep(documentData),
        srps: srpsCalculation(
            documentData.product?.category?.name ?? '',
            documentData?.netto ?? 0,
            documentData?.moisture ?? 0,
            documentData?.impurity ?? 0,
            documentData?.breakage ?? 0,
            documentData?.defect ?? 0,
            documentData?.hectoliter as number,
            documentData.calculationMethod as boolean,
            settings
            )[0],
    };
    return templateData;
}
